import { ShareDetailsPageContextType } from '../types/ShareDetailsPageContextType';

export const shareDetailPageInitValue: ShareDetailsPageContextType = {
  data: {
    from: 0,
    to: 0,
    price: 0,
    nominalValue: 0,
    premium: 0,
    tag: '',
    partner: null,
    holdingClass: null,
    operation: null,
    encumbrancesTotal: 0,
    encumbrances: [],
    expandedRows: new Set<number>(),
    page: 0,
    rowsPerPage: 0,
    isAdmin: false,
    isReadOnly: false,
    isLoading: false,
  },
  actions: {
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
    handleEditShare: () => {},
    handleToggleRowExpansion: () => {},
    handleAddEncumbrance: () => {},
    handleEditEncumbrance: () => {},
    handleViewEncumbrance: () => {},
    handleRemoveEncumbrance: () => {},
  },
};
